import { EmptyState, Skeleton } from '../../../components';
import { useLang } from '../../../i18n';
import type { MissionItem } from '../../../types';
import { resolveIcon } from '../hooks/useIcon';
import './MissionSection.scss';

export interface MissionSectionProps {
  items: MissionItem[];
  loading: boolean;
}

function renderBody(body: string) {
  const lines = body.split(/\n+/).filter((l) => l.trim().length > 0);
  if (lines.length <= 1) return <p className="about-mission__body">{body}</p>;
  return (
    <div className="about-mission__body">
      {lines.map((line, i) => (
        <p key={i}>{line}</p>
      ))}
    </div>
  );
}

export default function MissionSection({ items, loading }: MissionSectionProps) {
  const { t } = useLang();
  const showSkeleton = loading && items.length === 0;
  const empty = !loading && items.length === 0;

  return (
    <section className="section section--tight about-mission">
      <div className="container">
        <div className="section-header about-mission__head">
          <span className="eyebrow">{t('about.mission.t')}</span>
          <h2 className="about-mission__title">{t('about.mission.sub')}</h2>
        </div>

        {empty ? (
          <EmptyState title={t('about.empty')} />
        ) : (
          <div className="about-mission__grid">
            {showSkeleton
              ? [0, 1, 2].map((i) => (
                  <div key={i} className="card-frame about-mission__card">
                    <Skeleton width={48} height={48} shape="rect" />
                    <Skeleton width="60%" height={24} />
                    <Skeleton width="100%" height={14} />
                    <Skeleton width="90%" height={14} />
                  </div>
                ))
              : items.map((m) => {
                  const Icon = resolveIcon(m.icon_key || m.kind);
                  return (
                    <article key={m.id} className="card-frame about-mission__card">
                      <span className="about-mission__icon" aria-hidden="true">
                        <Icon size={22} />
                      </span>
                      <h3 className="about-mission__h3">{m.heading}</h3>
                      {renderBody(m.body)}
                    </article>
                  );
                })}
          </div>
        )}
      </div>
    </section>
  );
}
